import { render, staticRenderFns } from "./OperationBaseDetailed.vue?vue&type=template&id=2244d56a&scoped=true&"
import script from "./OperationBaseDetailed.vue?vue&type=script&lang=js&"
export * from "./OperationBaseDetailed.vue?vue&type=script&lang=js&"
import style0 from "./OperationBaseDetailed.vue?vue&type=style&index=0&id=2244d56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244d56a",
  null
  
)

export default component.exports